// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"869d5d98","388":"43f8c879","426":"b002abd3","453":"19a30ac3","574":"888f9cc0","798":"7b9c307a","849":"6a1c6fcb","981":"f744fd93","982":"6f15739b"}[chunkId] + ".chunk.js";
};